<template>
    <div
        class="card mt-2 event-card"
        v-bind:class="{
            border: is_editing,
            'border-danger': is_editing,
            shadow: is_editing,
            'border-primary': true
        }"
    >
            <!--
            'border-warning': this.question.is_default_question,
            'border-primary': !this.question.is_default_question,
            -->
    
        <div class="card-body">
            <p class="card-text small">
                <span v-if="is_editing">(Editing...)</span>
                <span style='color:DodgerBlue;padding-right: 10px;'><strong> [Event Action] {{event.text}} </strong></span>
                <!--
                <span style='color:red;' > [Event Span] </span><span style='color:red; font-style: italic;' >{{event_span}}</span>
                -->
            </p>
            <button
                    v-if="show_edit_button"
                    class="btn btn-warning btn-sm mr-2 tooltip-big-text"
                    v-on:click="onEdit"
                    data-toggle="tooltip"
                    :data-balloon-pos="edit_button_tooltip_loc"
                    :aria-label="edit_button_tooltip_text">
                <i class="fas fa-edit"></i>
            </button>

            <button
                    class="btn btn-danger btn-sm"
                    v-if="show_delete_button"
                    v-on:click="onDelete"
            >
                <i class="fas fa-trash-alt"></i>
            </button>

        </div>

    </div>
    <!--
    <div class="card">
        <div class="card-body">
            <p class="card-text">
                {{value}} &nbsp;
                <a
                        class="card-link text-danger"
                        style="cursor: pointer"
                        v-on:click="onDelete"
                >
                    <i class="fas fa-trash-alt"></i>
                </a>
            </p>
        </div>
    </div>
    -->
</template>

<script>
    export default {
        name: 'EventCard',
        
        components: {
        },
        
        props: ['event', 'is_editing', 'is_selecting'],
        
        computed: {
            show_edit_button: function(){
                
                if (this.is_editing || !this.is_selecting){
                    return false;
                }
                return true;
            },

            show_delete_button: function(){
                if (this.is_editing || !this.is_selecting){
                    return false;
                }

                return true;
            },

            edit_button_tooltip_text: function(){
                let default_text = "This button is to edit this event action.";
                return default_text;
            },

            edit_button_tooltip_loc: function(){
                return "right";
            },
        },

        mounted: function(){
        },

        methods: {
            onDelete: function(){
                this.$emit("delete");
            },
            onEdit: function(){
                this.$emit("edit");
            },
            onPin: function(){
                this.$emit("pin");
            },
            onUp: function(){
                this.$emit("up");
            },
            onDown: function(){
                this.$emit("down");
            }
        }
    }
</script>

<style>
</style>
